import ApiInstance from './instance'
import { ILetter, ILettersFiltersDTO, ILettersListResponseDTO, URL_MAPPING } from '@zunta/configurations'

const { statement: statementUrls } = URL_MAPPING

export default class LetterApi {
  instance: ApiInstance

  constructor (instance: ApiInstance) {
    this.instance = instance
  }

  fetchBatchLetters (batchId: number | string, filters: ILettersFiltersDTO): Promise<ILettersListResponseDTO> {
    return this.instance.doGet(`${statementUrls.prefix}${statementUrls.fetchBatchLetters.path}/${batchId}`, filters)
  }

  fetchLettersBatchStatistics (batchId: number | string) {
    return this.instance.doGet(`${statementUrls.prefix}${statementUrls.fetchLettersBatchStatistics.path}/${batchId}`)
  }

  getLetterById (letterId: number | string): Promise<ILetter> {
    return this.instance.doGet(`${statementUrls.prefix}${statementUrls.getLetterById.path}/${letterId}`, {}, 'getLetterById')
  }
}
